import { Reducer } from 'interfaces'
import { VideoCallsDetails } from 'components/features/videoCalls/types/state'
import {
  AgoraPinVideoAction,
  AgoraUnPinVideoAction,
  AgoraSetActiveSpeakerAction,
  AgoraClientEventAction,
  AgoraLeaveChannelAction,
  AgoraStreamEventAction,
} from 'components/features/videoCalls/types/actions'

const handleLeave = (prevState: VideoCallsDetails, id: number) => {
  const isPinnedStream = prevState.pinnedStreamId === id
  const isSpeakerStream = prevState.speakerStreamId === id

  return {
    ...prevState,
    ...isPinnedStream ? { pinnedStreamId: null } : {},
    ...isSpeakerStream ? { speakerStreamId: null } : {},
  }
}

export const videoCallDetailsReducer: Reducer<VideoCallsDetails> = (prevState = new VideoCallsDetails(), action): VideoCallsDetails => {
  switch (action.type) {
    case AgoraSetActiveSpeakerAction.type: {
      return {
        ...prevState,
        speakerStreamId: action.payload,
      }
    }

    case AgoraPinVideoAction.type: {
      return {
        ...prevState,
        pinnedStreamId: action.payload.streamId,
      }
    }

    case AgoraUnPinVideoAction.type: {
      return {
        ...prevState,
        pinnedStreamId: null,
      }
    }

    case AgoraLeaveChannelAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return new VideoCallsDetails()
    }

    case AgoraClientEventAction.type: {
      const event = action.payload
      switch (event.type) {
        case 'stream-removed': {
          const id = +(event.stream?.getId() || 0)
          return handleLeave(prevState, id)
        }

        case 'peer-leave': {
          const id = +event.uid
          return handleLeave(prevState, id)
        }

      }

      return prevState
    }

    case AgoraStreamEventAction.type: {
      const event = action.payload
      switch (event.type) {
        case 'audioTrackEnded':
        case 'videoTrackEnded': {
          return {
            ...prevState,
            interrupted: true,
          }
        }
      }

      return prevState
    }

  }
  return prevState
}
